const styles = {
  nameStyle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '14px',
    marginBottom: '5px',
  },
  nameStyleCompressed: {
    marginBottom: '0px',
  },
  descriptionStyle: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    lineHeight: '12px',
  },
  selectedStyle: {
    backgroundColor: '#CED7D9',
  },
  rowStyle: {
    fontFamily: 'Roboto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    outline: 'none',
    cursor: 'pointer',
    color: 'rgb(71, 97, 102)',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  cellStyle: {
    display: 'flex',
    padding: '10px',
    textAlign: 'left',
    verticalAlign: 'middle',
    fontSize: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
    flexBasis: '15%',
    height: '95px',
  },
  cellStyleCompressed: {
    display: 'flex',
    textAlign: 'left',
    verticalAlign: 'middle',
    fontSize: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
    flexBasis: '15%',
    padding: '0px 10px',
    height: '40px',
  },
  imageFill: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  checkbox: {
    style: {
      color: '#17E685',
      height: '100%',
      width: 'auto',
    },
    icon: { fill: 'red !important' },
  },
  flexContainer: {
    display: 'flex',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListTable/ProjectListElement/ProjectListElement.styles.js